export const sortTypes = {
    SORT_UPDATE: 'SORT_UPDATE',
    SORT_TOGGLE: 'SORT_TOGGLE',
    CLEANUP: 'SORT_CLEANUP'
};


